import React from 'react';
import { enableMapSet } from 'immer';
import { createRoot } from 'react-dom/client';
import { App } from 'app';

enableMapSet();

const render = (): void => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const root = createRoot(document.getElementById('root')!);
  root.render(<App />);
};

render();
export type { FetchTranslationsProps } from 'utils/i18n/Translations';
